// extracted by mini-css-extract-plugin
export default {"statusChip":"status-chip_statusChip__fSMXN","statusChipWithBadge":"status-chip_statusChipWithBadge__LewC9","badgeIcon":"status-chip_badgeIcon__aAoVZ"};